module.exports = __webpack_public_path__ + "static/media/sikinitem-fallback.1e0de742.svg";